import React from "react";
import styled from "styled-components";

import { bgColor, borderBottom, centerContent, fgColor } from "~/styles/mixins";

export interface VerticalTabProps {
  index: number;
  error?: boolean;
  selected?: boolean;
  icon?: React.ReactNode;
  label?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const VerticalTab = React.forwardRef<HTMLButtonElement, VerticalTabProps>(
  function VerticalTab({ index, error, selected, icon, label, onClick }, ref) {
    return (
      <StyledButton
        ref={ref}
        id={`tab-${index}`}
        type="button"
        role="tab"
        aria-selected={selected}
        $error={error}
        $selected={selected}
        className={selected ? "active" : undefined}
        onClick={onClick}
      >
        <LabelIconGroup>
          {icon}
          {label}
        </LabelIconGroup>
      </StyledButton>
    );
  }
);

const LabelIconGroup = styled.span`
  display: flex;
  gap: 10px;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledButton = styled.button<{ $error?: boolean; $selected?: boolean }>`
  appearance: none;
  border: none;
  width: 100%;
  text-align: left;
  text-transform: none;
  ${(props) => (props.$selected ? "background-color: white;" : "")}
  cursor: pointer;

  line-height: 28px;
  ${centerContent};
  ${bgColor.gray100()};
  ${(props) => (props.$error ? fgColor.red() : fgColor.black())};
  flex: 1;
  height: 40px;
  min-height: 40px;
  max-width: 100%;
  font-size: 14px;
  font-weight: bold;
  justify-content: left;

  &:last-child {
    border-bottom: none;
  }

  ${borderBottom.gray300()};

  &:focus {
    outline: 0;
  }

  &:hover {
    ${(props) => (props.$error ? fgColor.red() : fgColor.black())};
    text-decoration: none;
  }

  &.active {
    ${bgColor.white()};
    cursor: default;
    pointer-events: none;
  }
`;

export default VerticalTab;
